module.exports = __webpack_public_path__ + "static/media/ver-carrito.795b5fc7.png";